import { useEffect, useState } from "react";
import { msUntilNextDay } from "@mk/shared";
import { gameEdition } from "../lib/edition.ts";
import { messages } from "../i18n/index.ts";

function pad(value: number): string {
  return String(value).padStart(2, "0");
}

function format(ms: number): string {
  const total = Math.max(0, Math.floor(ms / 1000));
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;
  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
}

/**
 * Sonraki günlük kelimeye kalan süre.
 *
 * Gün sınırı Türkiye saatiyle gece yarısı — kullanıcı hangi saat diliminde
 * olursa olsun geri sayım aynı anı gösterir. Süre dolduğunda kendi kendine
 * yeni güne dönüyor; kullanıcının sayfayı yenilemesi gerekmiyor.
 */
export function NextWordCountdown() {
  const [remaining, setRemaining] = useState(() =>
    msUntilNextDay(Date.now(), gameEdition.timeZone),
  );

  useEffect(() => {
    const id = window.setInterval(
      () => setRemaining(msUntilNextDay(Date.now(), gameEdition.timeZone)),
      1000,
    );
    return () => window.clearInterval(id);
  }, []);

  return (
    <p className="next-word" role="status">
      <span className="next-word__label">{messages.countdown.nextWord}</span>
      <time className="next-word__value">{format(remaining)}</time>
    </p>
  );
}
